import { render, staticRenderFns } from "./StatsContainer.vue?vue&type=template&id=00b21696&"
import script from "./StatsContainer.vue?vue&type=script&lang=js&"
export * from "./StatsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports